import { Language, Tab } from '@yleisradio/areena-types';

const settingsViewId = '57-w1nen4N2k';

export const views = {
  FRONT: 'front',
  RADIO_FRONT: 'radio-front',
  FAVORITES: 'omat',
  TV_LIVE: 'live',
  SETTINGS: settingsViewId,
};

export const tabSlugToTabIndex = (
  slug: string | undefined,
  tabs: Tab[] | undefined
): number | undefined => {
  if (slug) {
    const tabIndex = tabs?.findIndex(
      tab => tab.slug === slug || tab.alternateSlug?.fi === slug
    );
    if (typeof tabIndex === 'number' && tabIndex >= 0) {
      return tabIndex;
    }
  }
  return;
};

export const getAppTitle = (language: Language) => {
  return language === 'sv' ? 'Yle Arenan' : 'Yle Areena';
};
